<div class="form-group">
  <label for="fieldOption.label" class="form-label">
    {{ fieldOption.name }}
    <span *ngIf="fieldOption.validator[0].required">*</span>
  </label>

  <p-dropdown
    [options]="dropdownList"
    [style]="{ width: '100%' }"
    inputStyleClass="w-full"
    [(ngModel)]="valueOfData"
    optionLabel="name"
    [placeholder]="fieldOption.place_holder"
    [disabled]="fieldOption.disabled"
    [required]="fieldOption.validator.required"
    [name]="fieldOption.name"
    (ngModelChange)="onInputChange()"
    (change)="onInputChange()"
    appendTo="body"
  ></p-dropdown>

  <span class="text-danger" *ngIf="requiredError"
    >{{ fieldOption.name }} is required</span
  >

</div>
